import { createChildPath } from '../../../utils';
import generateAsyncRouteComponent from '../../../generateAsyncRouteComponent';

export default {
  path: createChildPath('confirmation'),
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/ReturnConfirmationPage'),
  }),
};
